// Activities type found on activity > location > type
export const ACTIVITIES_TYPE = {
  MULTYPOLYGON: 'MultiPolygon',
  POLYGON: 'Polygon',
  POINT: 'Point',
};

export const ASSET_ACCEPTED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
];

export const REGION_SYMBOLS = {
  RECTANGLE: '▢',
  PIVOT: '◯',
  POLYGON: '☖',
};

export const REGION_SHAPES = {
  RECTANGLE: 'rectangle',
  PIVOT: 'circle',
  POLYGON: 'polygon',
};
